/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { WhatIfData } from "../../models/http/what-if/what-if-data.model";
import { CommunicationService } from "../communication.service";
import { HttpMethods } from "../../models/ui/http-methods.model";
import { ENDPOINT_GROUPS } from "../../utils/apis/apis.constants";

@Injectable({
	providedIn: "root"
})
export class WhatIfHttpService {
	private _whatIfOperations = ENDPOINT_GROUPS.whatIf.operations;

	constructor(private _communicationService: CommunicationService) {}

	/**
	 * Retrieves the "What If" data for a specific user.
	 *
	 * @param appId - The application ID.
	 * @param tenantId - The tenant ID.
	 * @param time - (Optional) The specific time for which to retrieve the data.
	 * @returns An Observable that emits the WhatIfData.
	 */
	public getUserWhatIfData(
		appId: string,
		tenantId: string,
		time?: string
	): Observable<WhatIfData> {
		const params = new HttpParams({
			fromObject: {
				tenantId,
				...(time && { time })
			}
		});

		const pathParams = { appId };

		return this._communicationService.callService(
			this._whatIfOperations.getUserWhatIfData.service,
			HttpMethods.GET,
			{ params, pathParams }
		);
	}
}
